module.exports = __webpack_public_path__ + "static/media/nike-eor-winning-isnt-for-everyone-winner.4a566855.mp4";